
import { EntityConfig } from './types';

export const CAMPAIGN_CONFIG: EntityConfig = {
  entityType: 'campaign',
  tableName: 'campaign_research_attachments',
  entityIdColumn: 'campaign_id',
  researchLimit: 4,
  queryKey: ['campaign-attached-research'],
  displayName: 'Campaign Research'
};
